import { PreferenceAssetDetail } from "../@types/UserPreferences"
import useGeneralContext from "../context/GeneralContext"

export default function useFollowingAssets() {
    const { userFollowingAssets, setUserFollowingAssets } = useGeneralContext()

    function addAsset(asset: PreferenceAssetDetail) {
        return setUserFollowingAssets([
            asset,
            ...userFollowingAssets
        ])
    }

    function removeAsset(encodedId: string) {
        const newState = userFollowingAssets.filter((asset) => asset.encoded_id !== encodedId);
        setUserFollowingAssets(newState)
    }

    return {
        addStateAsset: addAsset,
        removeStateAsset: removeAsset,
    }
}